import React, { useState, useRef, useEffect } from 'react';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/solid';
import './ChatBot.css';

const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const bottomRef = useRef(null);

  // Auto-scroll to latest message
  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const sendMessage = async () => {
    if (!input.trim()) return;

    // Add user message
    setMessages(prev => [...prev, { role: 'user', text: input }]);
    const userInput = input;
    setInput('');

    try {
      const res = await fetch("https://srishtidangwal-backend-1.onrender.com/api/message", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userInput }),
      });

      if (!res.ok) throw new Error('Network response was not ok');
      const data = await res.json();
      setMessages(prev => [...prev, { role: 'bot', text: data.reply || 'No reply from bot.' }]);
    } catch (err) {
      setMessages(prev => [...prev, { role: 'bot', text: 'Something went wrong!' }]);
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') sendMessage();
  };

  return (
    <div className={`chat-widget${isOpen ? ' open' : ''}`}>
      <button className="chat-toggle" onClick={() => setIsOpen(open => !open)} aria-label="Toggle chat">
        <ChatBubbleLeftRightIcon className="chat-icon" />
      </button>

      {isOpen && (
        <div className="chat-container">
          <h3>Dr. Srishti&apos;s Assistant</h3>

          <div className="chat-box">
            {messages.map((msg, i) => (
              <div key={i} className={`chat-message ${msg.role}`}>
                {msg.text}
              </div>
            ))}
            <div ref={bottomRef} />
          </div>

          <div className="chat-input">
            <input
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Ask a dental question..."
              aria-label="Type your message"
            />
            <button onClick={sendMessage} disabled={!input.trim()}>
              Send
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatBot;